import checkFilterForURLBuilder from "./checkFilterTypeURLBuilder";

export default function urlBuilder(
  baseUrl,
  pagination,
  sortingField,
  sortingDirection,
  search,
  columnFilters,
  exportCSV,
) {
  const { pageIndex, pageSize } = pagination;

  let url = `${baseUrl}?page=${pageIndex + 1}&pageSize=${pageSize}`;

  if (search) {
    url += `&search=${encodeURIComponent(search)}`;
  }

  if (sortingField) {
    url += `&sort=${sortingField}:${sortingDirection}`;
  }

  //build filters for URL, separate normal filters and date filters
  const { normal, checkboxFilters, date } =
    checkFilterForURLBuilder(columnFilters);

  if (normal.length > 0) {
    url += `&filter=${normal.join(";")}`;
  }

  if (checkboxFilters.length > 0) {
    url += `&checkboxFilters=${checkboxFilters.join(";")}`;
  }

  if (date.length > 0) {
    url += `&date=${date.join(";")}`;
  }

  if (exportCSV) {
    url += `&export=true`;
  }

  return url;
}
